/*
 * massage-intake (schema)
 */
import { boolean, integer, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"
import { patients } from "../patient/patient.schema"
import { practitioners } from "../practitioner/practitioner.schema"

export const massageIntakes = schema.table("massage_intakes", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id")
		.notNull()
		.references(() => patients.id, { onDelete: "cascade" }),
	therapistId: uuid("therapist_id").references(() => practitioners.id, { onDelete: "set null" }),

	// --- Chief Complaint ---
	mainComplaint: text("main_complaint"),
	painLocation: text("pain_location"),
	painScale: integer("pain_scale"),
	painDuration: text("pain_duration"),

	// --- Medical History ---
	medicalConditions: text("medical_conditions"),
	medications: text("medications"),
	allergies: text("allergies"),
	recentSurgeries: text("recent_surgeries"),

	// --- Massage History ---
	previousMassage: boolean("previous_massage").default(false),
	previousMassageNotes: text("previous_massage_notes"),
	massageGoals: text("massage_goals"),
	preferredPressure: varchar("preferred_pressure", { length: 32 }),

	// --- Contraindications ---
	contraindications: text("contraindications"),

	// --- Lifestyle ---
	occupation: text("occupation"),
	stressLevel: integer("stress_level"),
	sleepQuality: text("sleep_quality"),
	exerciseFrequency: text("exercise_frequency"),

	// --- Additional ---
	additionalNotes: text("additional_notes"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
